import { notification, Skeleton } from 'antd';
import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import asiceIcon from '@/assets/file-icons/asice.png';
import { useSignedContractPdf } from '@/features/contracts/api/use-download-signed-contract';
import { downloadFile } from '@/utils/download-file';

type DownloadSignedContractButtonProps = {
  contractId: number;
};

const DownloadSignedContractButton = ({ contractId }: DownloadSignedContractButtonProps) => {
  const { t } = useTranslation();
  const downloadSignedContractQuery = useSignedContractPdf({ params: { contractId }, queryConfig: { enabled: false } });

  const handleDownload: MouseEventHandler<HTMLButtonElement> = async (event) => {
    event.stopPropagation();

    const response = await downloadSignedContractQuery.refetch();
    const blob = response?.data?.data;

    if (!blob) {
      return notification.error({
        message: t('somethingWentWrong', { ns: 'common' }),
      });
    }

    downloadFile(blob, `Contract ${contractId}.asice`);
  };

  return (
    <button
      disabled={downloadSignedContractQuery.isLoading}
      onClick={handleDownload}
      key="signed-contract"
      className="flex flex-col gap-2 col-span-1 lg:order-9 md:order-7 sm:order-9 order-9 sm:items-start items-end"
    >
      {downloadSignedContractQuery.isLoading ? (
        <Skeleton.Node className="rounded-sm w-6 h-6" active />
      ) : (
        <span className="text-gray-10 font-medium leading-[24px]">
          <img src={asiceIcon} alt="ascie" width={24} height={24} />
        </span>
      )}
      <span className="text-brand-brown underline font-normal">{t('download', { ns: 'common' })}</span>
    </button>
  );
};

export default DownloadSignedContractButton;
